/**
 * Component/Page name validation constants for NameAndTag component.
 */
export const COMPONENT_NAME_LOCATION = 'ComponentName';
export const DYNAMIC_COMPONENT_ROUTE = 'ComponentRoute';
export const NAME_TAGS_LOCATION = 'Tags.NameTags';
export const PAGE_NAME_LOCATION = 'PageName';
export const USER_TAGS_LOCATION = 'Tags.UserTags';

/**
 * Modal messages
 */
export const MODAL_MESSAGES = {
  CANCEL_LABEL: 'Cancel',
  DELETE_LABEL: 'Delete',
  FOLDER_LABEL: 'folder',
  CONTENT_LABEL: 'content',
  CONFIRMATION_HEADER_MESSAGE: '%s %s confirmation',
  DELETE_CONTENT_MESSAGE:
    ' Once deleted this %s %s cannot be recovered. Are you sure you want to delete? ',
  RENAME_CONTENT_MESSAGE: ' Are you sure you want to rename %s %s ? ',
  RENAME_LABEL: 'Rename',
  LIVE_TEXT_EDITOR_FAILED_MESSAGE:
    "There's one or more error with the link(s) you added to the Live Text Editor. Check to ensure they're correct."
};

export const CONTENT_TYPES = Object.freeze({
  FOLDER: 'folder',
  PAGE: 'page',
  COMPONENT: 'component',
  REPORT: 'report',
  MASTER_COMPONENT: 'master component',
  DYNAMIC_COMPONENT: 'dynamic component',
  CONTENT_ENRICHMENT: 'content enrichment'
});

export const ARRAY_SELECTION_WIDGETS = ['CheckBoxList'];

// canvas sites
export const REAL_ROOT_FOLDER_ID = 'ROOT';
export const SITE_ROOT_FOLDER_ID_HAUTE_LOOK = '000000HL-0000-0000-0000-000000000000';
export const SITE_ROOT_FOLDER_ID_NORDSTROM = '00000000-0000-0000-0000-000000000000';
export const SITE_ROOT_FOLDER_ID_NORDSTROM_RACK = '000000NR-0000-0000-0000-000000000000';

export const HAUTE_LOOK = 'HauteLook';
export const NORDSTROM = 'Nordstrom';
export const NORDSTROM_RACK = 'Nordstrom Rack';
export const ALL_SITES = [NORDSTROM, NORDSTROM_RACK, HAUTE_LOOK];
export const SITE_ROOT_FOLDER_NAMES = {
  [SITE_ROOT_FOLDER_ID_NORDSTROM]: NORDSTROM,
  [SITE_ROOT_FOLDER_ID_HAUTE_LOOK]: HAUTE_LOOK,
  [SITE_ROOT_FOLDER_ID_NORDSTROM_RACK]: NORDSTROM_RACK
};

/**
 * Malformed link validation constants
 */
export const LINK_PREFIX = {
  ABSOLUTE_NAME: 'absolute',
  ANCHOR: '#',
  HTTP: 'http:',
  HTTPS: 'https:',
  HLIOS: 'hlios://',
  HLIOS_RACK: 'hlios-rack://',
  MAILTO: 'mailto:',
  NORDSTROM: 'nordstrom://',
  RELATIVE: '/',
  TEL: 'tel:',
  WWW: 'www.'
};

export const DEFAULT_BOUND_VALUE = '2';
export const BOUND_PROPLOCATION_PATH = 'Payload.subcomponentsBound';
export const CONTENT_POOL_EXCEPTION_MESSAGE = "'Tiles' has minimum length 2.";
